module.exports = __webpack_public_path__ + "img/606.918df645.jpg";